import CssBaseline from "@mui/material/CssBaseline";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { Loader } from "@talkouttech/portal-shared";
import { StrictMode, Suspense } from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import App from "./App";
import { AppProviders } from "./context/AppProviders";
import "./language/i18n";
import reportWebVitals from "./reportWebVitals";
import { globalStyles } from "./styles";
import { tagManagerArgs } from "./utils/gtmDataLayers";
interface AppConfig {
  AUTH0_DOMAIN: string;
  AUTH0_AUDIENCE: string;
  AUTH0_CLIENTID: string;
  API_URL: string;
  APP_URL: string;
  ENVIRONMENT_NAME: string;
  GTM_ID: string;
  GTM_AUTH: string;
  GTM_PREVIEW: string;
  GIPHY_API_KEY: string;
  AUTOMATION_API_BASE_URL_OVERRIDE: string;
  REVIEW_API_BASE_URL_OVERRIDE: string;
}

declare global {
  interface Window {
    APP_CONFIG: AppConfig;
  }
}

TagManager.initialize(tagManagerArgs);
// MUI-X Pro License.
// Documentation states this is designed to be publicly visible and should be embedded in source, env var mapping is not required
LicenseInfo.setLicenseKey(
  "b098a0710e8abc776af9e5ddea2668f1Tz0xMzA3NjksRT0xODE2MzQ0MDAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
);

ReactDOM.render(
  <Suspense fallback={<Loader />}>
    <AppProviders>
      <StrictMode>
        <CssBaseline />
        {globalStyles}
        <App />
      </StrictMode>
    </AppProviders>
  </Suspense>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
